import { Link } from 'react-router-dom';
import { RouteListType } from '../../domain/shared/RoutesType';

interface Props {
    nestedRoutes: RouteListType;
}

export default function Breadcrumb({ nestedRoutes }: Props) {
    return (
        <nav aria-label='breadcrumb m-0 p-0' className=''>
            <ol className='breadcrumb  my-0 py-1'>
                {nestedRoutes.map((route, i) => {
                    return (
                        <li
                            key={i}
                            className='breadcrumb-item active p-1'
                            aria-current='page'
                        >
                            <Link
                                to={route.route}
                                style={{
                                    color: '#929292',
                                    fontWeight: 500,
                                }}
                            >
                                {route.label}
                            </Link>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
